import { formatApptDayInStopTz } from 'components/Kit/EmailSuggestions/getValidChangeElements';
import { getSuggestionDescriptor } from 'components/Kit/EmailSuggestions/utils/suggestionFormatters';
import { MaybeUndef } from 'types/UtilityTypes';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';

export type BuiltLoadRowText = {
  // "Chicago, IL to Dallas, TX", or the card's usual descriptor when a stop has no city
  lane: string;
  // "Sep 29", or empty when the pickup has no time
  pickupDay: string;
};

// What a built row shows: the lane, then the pickup day. How the load was found and when show in
// the row's tooltip, like a handled quote.
export function formatBuiltLoadRow(
  suggestion: LoadBuildingSuggestions
): BuiltLoadRowText {
  const suggested = suggestion.suggested;
  const pickupDay = formatApptDayInStopTz(
    suggested?.pickup?.apptStartTime ?? suggested?.pickup?.readyTime,
    suggested?.pickup?.timezone
  );

  return {
    lane:
      formatLane(suggested?.pickup, suggested?.consignee) ||
      getSuggestionDescriptor(suggestion),
    pickupDay,
  };
}

type StopPlace = MaybeUndef<{ city: string; state: string }>;

function formatLane(pickup: StopPlace, consignee: StopPlace): string {
  const origin = formatPlace(pickup);
  const destination = formatPlace(consignee);
  if (!origin || !destination) {
    return '';
  }
  return `${origin} to ${destination}`;
}

function formatPlace(stop: StopPlace): string {
  return [stop?.city, stop?.state].filter(Boolean).join(', ');
}
